import { useEffect, useState } from "react";

import { ProductInfo } from "../types";
import { getProductInfo } from "../api";
import { redirectToMainPage } from "../utils";

export function useLoadProductInfo(productId: string): ProductInfo | null {
    const [productInfo, setProductInfo] = useState<ProductInfo | null>(null);

    useEffect(() => {
        const controller = new AbortController();

        getProductInfo(productId, controller.signal)
            .then(setProductInfo)
            .catch(error => {
                if (error?.name === "AbortError") return;
                redirectToMainPage();
            });

        return () => controller.abort();
    }, [productId]);

    return productInfo;
}
